import { connect } from 'react-redux'

import GroupOrderSchedulePlanner from '@components/groupOrders/SchedulePlanner/GroupOrderSchedulePlanner'

import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { HandleError } from '@coordinators/composed'

const mapStateToProps = (state: any) => {
  const { user } = state
  const { lastLoggedInHq, id, email } = user || {}

  return {
    hq: lastLoggedInHq,
    userId: id,
    userEmail: email,
  }
}

const mapDispatchToProps = () => {
  const { ChefService, RestService, UIService } = services
  const {
    AsyncLoadAccounts,
    LoadChefs,
    LoadGOScheduleCuisines,
    AdvancedSearchClientSettings,
    SearchGOMenus,
    GetDateMenuTemplate,
    CreateDateMenuTemplate,
    UpdateDateMenuTemplate,
    SearchDateMenuTemplates,
    DeleteDateMenuTemplates,
  } = coordinators
  const {
    pRequestSearchGOMenusParams,
    pResponseGeneric,
    pResponseGOMenus,
    pResponseGOSchedulePlannerClientSettings,
    pResponseChefs,
  } = presenters.Api
  const { displayFailureMessage, displayInfoMessage } = UIService.FlashMessage
  const displayConfirmationModal = UIService.ConfirmationModal.show

  const loadAccounts = AsyncLoadAccounts({ RestService, pResponseGeneric })
  const loadChefs = LoadChefs({ RestService, pResponseChefs, ChefService })
  const loadCuisines = LoadGOScheduleCuisines({ RestService, HandleError })
  const searchClientSettings = AdvancedSearchClientSettings({
    RestService,
    HandleError,
    pResponseGroupOrderClientSettings: pResponseGOSchedulePlannerClientSettings,
  })
  const searchGOMenus = SearchGOMenus({
    RestService,
    pRequestSearchGOMenusParams,
    pResponseGOMenus: pResponseGOMenus as any,
    HandleError,
  })
  const showInfoModal = UIService.InfoModal.displayInfoModal
  const closeInfoModal = UIService.InfoModal.dismissInfoModal
  const getDateMenuTemplate = GetDateMenuTemplate({ RestService, HandleError })
  const createDateMenuTemplate = CreateDateMenuTemplate({
    RestService,
    HandleError,
  })
  const updateDateMenuTemplate = UpdateDateMenuTemplate({
    RestService,
    HandleError,
  })
  const searchDateMenuTemplates = SearchDateMenuTemplates({
    RestService,
    HandleError,
  })
  const deleteDateMenuTemplates = DeleteDateMenuTemplates({
    RestService,
    HandleError,
  })

  return {
    searchClientSettings,
    searchGOMenus,
    closeInfoModal,
    showInfoModal,
    loadAccounts,
    loadChefs,
    loadCuisines,
    displayFailureMessage,
    displayInfoMessage,
    getDateMenuTemplate,
    createDateMenuTemplate,
    updateDateMenuTemplate,
    searchDateMenuTemplates,
    deleteDateMenuTemplates,
    displayConfirmationModal,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GroupOrderSchedulePlanner)
